module.exports = "/assets/logo_sg_photoshopexpress-9e34fb4824f8410074bb415f4619399e.png";